/**
 * New Pivony accounts wait for an operator's approval. Until then users/token
 * and users/pre_auth_check answer 403 with one of these codes, and the login
 * page explains it instead of a generic "Login not authorized".
 */
export const ACCOUNT_PENDING_APPROVAL = "ACCOUNT_PENDING_APPROVAL";
export const ACCOUNT_REJECTED = "ACCOUNT_REJECTED";
const CODES = [ACCOUNT_PENDING_APPROVAL, ACCOUNT_REJECTED];

// App.js signs the user out and sends them to /login; this carries the reason across.
export const ACCOUNT_REVIEW_STORAGE_KEY = "accountReview";

export const accountReviewCode = (result) => {
  const code = result?.code || result?.error_code;
  return CODES.includes(code) ? code : null;
};

export const rememberAccountReview = (code, storage = window.sessionStorage) => {
  try {
    storage.setItem(ACCOUNT_REVIEW_STORAGE_KEY, code);
  } catch (_) {
    // Private mode or blocked storage: the login page still works, just without the note.
  }
};

/** Reads the reason once and clears it, so a reload shows the plain login page. */
export const takeAccountReview = (storage = window.sessionStorage) => {
  try {
    const code = storage.getItem(ACCOUNT_REVIEW_STORAGE_KEY);
    storage.removeItem(ACCOUNT_REVIEW_STORAGE_KEY);
    return CODES.includes(code) ? code : null;
  } catch (_) {
    return null;
  }
};

export const accountReviewNotice = (code, t) =>
  code === ACCOUNT_REJECTED
    ? {
        type: "error",
        title: t("login_page.account_rejected_title", "This account was not approved"),
        description: t(
          "login_page.account_rejected_desc",
          "If you think this is a mistake, contact support@pivony.com."
        ),
      }
    : {
        type: "info",
        title: t("login_page.account_pending_title", "Your account is waiting for approval"),
        description: t(
          "login_page.account_pending_desc",
          "We review every new Pivony account. You can sign in as soon as it is approved; we will email you."
        ),
      };
